export const loadBlogPosts = async (language: string): Promise<any[]> => {
  try {
    const posts = await import(`./posts/${language}/posts.json`);
    return posts.default;
  } catch (error) {
    console.error(`Error loading blog posts for language: ${language}`, error);
    return [];
  }
};
